<template lang="pug">
  .nav-drawer.component
    .link
      bf-link.combo( v-if='user' :to='{ name: "welcome" }' )
        template(v-slot:icon)
          home-icon
        template(v-slot:text) {{ $t('User Home') }}

    .link
      bf-link.combo( v-if='user' :to='{ name:  account.merchant ? "business-profile" : "profile" }' )
        template(v-slot:icon)
          profile-icon
        template(v-slot:text) {{ $t('Profile') }}
    
    //- .link
    //-   bf-link.combo( v-if='user' :to='{ name: "settings" }' )
    //-     template(v-slot:icon)
    //-       settings-icon
    //-     template(v-slot:text) {{ $t('Settings') }}

    .link
      bf-link.combo( v-if='user' :to='{ name: "merchants" }' )
        template(v-slot:icon)
          list-icon
        template(v-slot:text) {{ $t('List of Merchants') }}
    
    .link
      bf-link.combo( v-if='user' :to='{ name: "referrals" }' )
        template(v-slot:icon)
          refer-icon
        template(v-slot:text) {{ $t('Referral Program') }}

    template( v-if='account.id && !account.merchant' )
      bf-divider.on-dark
      .link.upgrade
        bf-link.combo(
          :to='{ name: "upgrade" }'
        )
          template(v-slot:icon)
            upgrade-icon
          template(v-slot:text) {{ $t('Become a Merchant') }}
      bf-divider.on-dark
    
    .link
      bf-link.combo(:to='{ name: "pricetable" }')
        template(v-slot:icon)
          money-icon
        template(v-slot:text) {{ $t('Price Table') }}

    .link
      bf-link.combo(:to='{ name: "about-us" }')
        template(v-slot:icon)
          about-icon
        template(v-slot:text) {{ $t('About BlueFaucet') }}

    .link
      bf-link.combo(:to='{ name: "contact-us" }')
        template(v-slot:icon)
          email-icon
        template(v-slot:text) {{ $t('Contact Us') }}

    .link
      bf-link.combo(:to='{ name: "help-center" }')
        template(v-slot:icon)
          help-icon
        template(v-slot:text) {{ $t('Help Center') }}

    .link
      bf-link.combo(:to='{ name: "privacy" }')
        template(v-slot:icon)
          privacy-icon
        template(v-slot:text) {{ $t('Privacy') }}

    bf-divider.on-dark

    template(v-if='user')
      .link
        bf-link.combo(@click.native='sign_out')
          template(v-slot:icon)
            sign-out-icon
          template(v-slot:text) {{ $t('Sign Out') }}

    template(v-else)
      .link
        bf-link.combo(:to='{ name: "sign-up" }')
          template(v-slot:icon)
            sign-in-icon
          template(v-slot:text) {{ $t('Sign Up') }}

      .link
        bf-link.combo(:to='{ name: "sign-in" }')
          template(v-slot:icon)
            sign-in-icon
          template(v-slot:text) {{ $t('Sign In') }}
</template>

<script>
  import { auth } from '@/main'

  export default {
    name: 'nav-drawer.component',

    props: {
      user: Object,
      account: [ Object, Array ],
      biz: Object,
      left: Boolean,
      scrolled: Boolean
    },

    methods: {
      sign_out() {
        auth.signOut().then( snap => this.$emit('signed-out') )
        this.$router.push('/')
      }
    }
  }
</script>

<style scoped lang="stylus">
  .nav-drawer
    // color black !important
  
  .link
    font-size 1.2em
    padding 0px 5px
    text-align left
    margin 0
    width 100%
    box-sizing border-box
    display flex
    justify-content flex-start
    color black
    &.toggle:hover
      background 0
      transform scale(1)
    &:first-child
      border-top 0
    &:last-child
      border-bottom 0
    &.upgrade
      color var(--clr-blue)

  .router-link-active
    // filter drop-shadow( 0 0 4px rgba(255 255 255 .5) )
    // font-weight bold
</style>
